import { useIntl } from 'react-intl'

import ROUTES from '~/constants/routes'

import msg from './HeaderList.messages'

export const useHeaderListArray = (): Option[] => {
  const { formatMessage } = useIntl()

  const HeaderListArray = [
    {
      label: formatMessage(msg.profile),
      value: ROUTES.profile
    }
  ]

  return HeaderListArray
}
